const StyleTokens  = require("@rawlplug/rawlplug-design-style-tokens/dist/js/variables");

const useMatchMedia = {
  install(Vue, options = {}) {
    const mql = window.matchMedia(`(max-width: ${StyleTokens.breakpoint.sm.max})`);
    Vue.prototype.$mql = mql;
    mql.addListener(function mediaQueryChanged(mediaQueryListEvent) {
      let size = e.matches ? 'mobile' : 'desktop';

      try {
        if (options.store) {
          options.store.commit('SET_DEVICE_SIZE', size);
        }
      } catch (e) {
        console.error('Pass store to matchMediaPlugin')
      }
    });
  }
}

module.exports = {
  useMatchMedia
}
